module.exports = __webpack_public_path__ + "img/monkey.3ba35172.svg";